import {
  signinUser,
  registerUser,
  fetchUser,
} from '../../utils/requests/index';
// import dotenv from "dotenv";
// import jwt from "jsonwebtoken";
import {
  USER_LOGIN_START,
  USER_LOGIN_FAIL,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_SIGNUP_FAIL,
  USER_SIGNUP_SUCCESS,
  USER_SIGNUP_START,
  USER_RELOAD_SUCCESS,
  GET_USER_NOTIFICATIONS_SUCCESS,
} from '../actionTypes';
import { toastSuccess } from '../../utils/helpers/helper';
import { fetchProjects, updateLikedProjects } from './projects/projects.action';
import { getNotificationsAPI } from '../../utils/requests/notification';
// import { setCurrentUser } from "../Auth/auth.action";

// dotenv.config();

export const userLoginStart = () => {
  return {
    type: USER_LOGIN_START,
  };
};

export const userLoginSuccess = (data) => {
  return {
    type: USER_LOGIN_SUCCESS,
    data,
  };
};

export const userLoginFailed = (authError) => {
  return {
    type: USER_LOGIN_FAIL,
    authError,
  };
};

export const userLogout = () => {
  return {
    type: USER_LOGOUT,
  };
};

export const userSignupStart = () => {
  return {
    type: USER_SIGNUP_START,
  };
};

export const userSignupSuccess = () => {
  return {
    type: USER_SIGNUP_SUCCESS,
  };
};

export const reloadSessionSuccess = (data) => {
  return {
    type: USER_RELOAD_SUCCESS,
    data,
  };
};

export const userSignupFailed = (authError) => {
  return {
    type: USER_SIGNUP_FAIL,
    authError,
  };
};

export const getNotificationSuccess = (notifications) => {
  return {
    type: GET_USER_NOTIFICATIONS_SUCCESS,
    notifications,
  };
};

export const authLogin = (
  userDetail,
  history = null,
  previousLocation = null
) => {
  const userDetails = {
    email: 'map@gmail.com',
    password: 'M15510n1',
  };
  return async (dispatch) => {
    dispatch(userLoginStart());

    return signinUser(userDetails)
      .then(async (response) => {
        const { access, refresh, user } = response;
        localStorage.setItem('token', JSON.stringify(access));
        localStorage.setItem('refresh', JSON.stringify(refresh));
        localStorage.setItem('user', JSON.stringify(user));
        await dispatch(userLoginSuccess(response));
        // toastSuccess('Login Successful');
        if (previousLocation) {
          setTimeout(() => {
            history.push(previousLocation);
          }, 5000);
        } else {
          setTimeout(() => {
            if (history) {
              history.push('/');
            }
          }, 5000);
        }
      })
      .catch((error) => {
        dispatch(userLoginFailed('email/password incorrect'));
      });
  };
};

export const authSignup = (userDetails, history) => {
  return (dispatch) => {
    dispatch(userSignupStart());
    return registerUser(userDetails)
      .then(async (response) => {
        dispatch(userSignupSuccess());
        history.push('/login');
      })
      .catch((error) => {
        Promise.resolve(error.data).then((err) => {
          dispatch(userSignupFailed(err));
        });
      });
  };
};

export const reloadSession = (userId) => {
  return (dispatch) => {
    return fetchUser(userId)
      .then(async (response) => {
        dispatch(reloadSessionSuccess(response));
        dispatch(updateLikedProjects(response?.account?.project_favorites));
        dispatch(fetchProjects());
      })
      .catch((error) => {});
  };
};

export const getUserNotifications = (userId) => {
  return (dispatch) => {
    return getNotificationsAPI()
      .then(async (response) => {
        dispatch(getNotificationSuccess(response));
      })
      .catch((error) => {});
  };
};

export const logout = () => {
  // remove token
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('refresh');
  return (dispatch) => {
    dispatch(userLogout());
  };
};
